import { SxProps } from '@mui/material';

export const QuizStyles = {
  container: {
    padding: '50px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  noContent: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: '200px',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    margin: '10px',
  },
  button: {
    margin: '5px',
    borderRadius: '20px',
    width: '100%',
    textTransform: 'none',
  },
  nextButton: {
    '&:disabled': {
      backgroundColor: 'rgb(208, 220, 243)',
    },
  },
  backButton: {
    '&:disabled': {
      borderColor: 'rgb(208, 220, 243)',
    },
  },
  completeQuizButtonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    position: 'absolute',
    right: '80px',
    top: '60px',
  },
} satisfies Record<string, SxProps>;
